import React, { useRef } from "react";
import { trackBuyflowEvent } from "@utils/api/tracker";
import styled from "@emotion/styled";
import CareFirstLogo from "./images/carefirst.webp";
import { getRouteId } from "src/utils/meristemContext";
import { breakpointMobileExtended } from "src/design-system/styles/breakpoints";
import { fontP2Regular } from "src/design-system/styles/fonts";
import { useTrackInViewport } from "src/hooks/viewport";
import i18n from "src/locales";
import { useUserData } from "src/hooks/redux";
import { compassColors } from "src/utils/styling";
import { getCareFirstRedirectUrl } from "src/utils/redirects";

const CareFirstContainer = styled.div`
  margin: 24px 0px;
  ${fontP2Regular}

  @media ${breakpointMobileExtended} {
    margin-top: 0px;
  }
`;

const CareFirstText = styled.div`
  margin: 12px 0px;
`;

const Logo = styled.img`
  height: 24px;
`;

const Link = styled.a`
  color: ${compassColors.denim};
`;

export function CareFirstCTA({
  pageId,
  surveyName,
}: {
  pageId: string;
  surveyName?: string;
}) {
  const ref = useRef();
  const userData = useUserData();
  useTrackInViewport(ref, "CareFirstSectionVisible", 0.5);

  const urlParams = new URLSearchParams(window.location.search);
  urlParams.append("lpsource", getRouteId());
  const redirectUrl = getCareFirstRedirectUrl(userData, urlParams);

  const onClick = (e) => {
    e.preventDefault();
    trackBuyflowEvent("BuyflowLinkClicked", {
      linkName: "careFirst",
      pageId,
      surveyName,
    });
    window.location.href = redirectUrl;
  };

  return (
    <CareFirstContainer ref={ref}>
      <Logo src={CareFirstLogo} alt={i18n.t("careFirstRedirect:imageAlt")} />
      <CareFirstText>{i18n.t("careFirstRedirect:description")}</CareFirstText>
      <Link onClick={onClick} href={redirectUrl}>
        {i18n.t("careFirstRedirect:eligible")}
      </Link>
    </CareFirstContainer>
  );
}
